const KEY = 'currentProject';

const initialState = {
  current: null, // { id, code, title, color, description, isDefault }
  list: [],
};

export default function projectReducer(state = initialState, action) {
  switch (action.type) {
    case 'project/setList':
      return { ...state, list: action.payload };
    case 'project/setCurrent':
      const cur = action.payload;
      if (cur) {
        localStorage.setItem(KEY, JSON.stringify(cur));
      } else {
        localStorage.removeItem(KEY);
      }
      return { ...state, current: cur };
    case 'project/loadFromStorage': {
      const json = localStorage.getItem(KEY);
      return json ? { ...state, current: JSON.parse(json) } : state;
    }
    default:
      return state;
  }
}

// actions
export const setProjectList = (list) => ({ type: 'project/setList', payload: list });
export const setCurrentProject = (p) => ({ type: 'project/setCurrent', payload: p });
export const loadProjectFromStorage = () => ({ type: 'project/loadFromStorage' });

// selectors
const selectProjectSlice = (state) => state.projects ?? state.project ?? { current: null, list: [] };

export const selectProjectList = (state) => selectProjectSlice(state).list;
export const selectCurrentProject = (state) => selectProjectSlice(state).current;
export const selectDefaultProject = (state) =>
  (selectProjectSlice(state).list || []).find((p) => p.isDefault) || null;

export const selectProjectByCode = (state, code) => {
  if (!code) return null;
  const norm = String(code).toUpperCase();
  return (selectProjectSlice(state).list || []).find(
    (p) => (p.code || "").toUpperCase() === norm
  ) || null;
};
